// extracted by mini-css-extract-plugin
module.exports = {"main":"course-content-display-module--main--35CUE"};